import { inject } from '@angular/core';
import type { HttpInterceptorFn } from '@angular/common/http';
import { AuthTokenService } from './auth-token.service';
import { environment } from '../../../environments/environment';

/**
 * Attach the doctor's bearer token to DoctorConsole API requests — and only those.
 *
 * Scoped by URL prefix rather than applied to everything: the partner webhook
 * and the translation server are other hosts, and a doctor's credential has no
 * business in their logs. A request that already names its own Authorization
 * header is left alone.
 */
export const apiAuthInterceptor: HttpInterceptorFn = (request, next) => {
  const apiUrl = environment.apiUrl;
  if (!apiUrl || !request.url.startsWith(`${apiUrl}/`) || request.headers.has('Authorization')) {
    return next(request);
  }

  const token = inject(AuthTokenService).token();
  if (!token) {
    return next(request);
  }

  return next(request.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
